import { useMemo } from 'react';
import type { OptionTypeBase } from 'react-select';

import {
  CreatableSelect,
  SelectComponents,
  type CreatableSelectProps,
} from '@frontend/legacy-components';

const getIsValidEmail = (value: string) => {
  const isValid = value.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );

  return Boolean(isValid);
};

export const EmailSelect = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  isValidNewOption: isValidNewOptionProp,
  createOptionPosition = 'last',
  ...restProps
}: CreatableSelectProps<OptionType, IsMulti>) => {
  const selectProps = useMemo(
    () =>
      ({
        formatCreateLabel: (value) => (
          <SelectComponents.CreateLabel
            value={value}
            verb="Use"
            entity=""
            createOptionPosition={createOptionPosition}
            showIcon={false}
          />
        ),
        filterOption: null,
        isValidNewOption: (...args) => {
          const isValidEmail = getIsValidEmail(args[0]);
          if (!isValidEmail) {
            return false;
          }

          return isValidNewOptionProp?.(...args) ?? true;
        },
        noOptionsMessage: ({ inputValue }) => {
          const isValidEmail = getIsValidEmail(inputValue);
          const defaultMessage = 'No results found.';

          if (!isValidEmail) {
            return `${defaultMessage} Please enter a valid email address.`;
          }

          return defaultMessage;
        },
        createOptionPosition,
        ...restProps,
      } satisfies CreatableSelectProps<OptionType, IsMulti>),
    [createOptionPosition, isValidNewOptionProp, restProps],
  );
  return <CreatableSelect {...selectProps} />;
};
